module.exports = __webpack_public_path__ + "img/1677.71cc81da.gif";